import React from 'react'

import * as style from './featured-title.module.scss'

type FeaturedTitleProps = Queries.DatoCmsHero

const FeaturedTitle: React.FC<FeaturedTitleProps> = ({ title, text }) => {
  return (
    <section className={style.section}>
      <div className="container">
        <div className="row">
          <div
            className={`col-12 col-md-8 offset-md-2 col-xl-6 offset-xl-3 text-center`}
          >
            <h2 className={`${style.title} text-base-000 h300`}>{title}</h2>
            <span className={`b100 text-uppercase text-base-000`}>{text}</span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeaturedTitle
